





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import DepositInterestSettingsEdit from '@/components/Products/Forms/Deposit/DepositInterestSettingsEdit.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'DepositInterestSettingsEditDialog', components: { DepositInterestSettingsEdit } })
export default class extends SaascadaVueDialog {

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            ProductDetailsModule.prepareProductViewModel();
            await ProductDetailsModule.getRateSources();
        }
    }

    get productType() {
        return ProductDetailsModule.product.generalSettings.subType;
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editDepositInterestSettings();
            await ProductDetailsModule.getHistory();
        }
    }

}
